import { Box, Divider, Skeleton } from '@frontend-workspace/react-shared-lib';
import { Col, Row } from 'reactstrap';

export function PeriodChurnReportSkeleton() {
  return <>
    <Box className='mb-5'>
      <Row>
        <Col md={6} xl={2}>
          <Skeleton animation="wave" width='100%' height={50} />
          <Skeleton animation="wave" width='100%' height={50} />
        </Col>
        <Col md={6} xl={2}>
          <Skeleton animation="wave" width='100%' height={50} />
          <Skeleton animation="wave" width='100%' height={50} />
        </Col>
        <Col md={6} xl={2}>
          <Skeleton animation="wave" width='100%' height={50} />
          <Skeleton animation="wave" width='100%' height={50} />
        </Col>
        <Col md={6} xl={2}>
          <Skeleton animation="wave" width='100%' height={50} />
          <Skeleton animation="wave" width='100%' height={50} />
        </Col>
        <Col md={6} xl={2}>
          <Skeleton animation="wave" width='100%' height={50} />
          <Skeleton animation="wave" width='100%' height={50} />
        </Col>
        <Col md={6} xl={2}>
          <Skeleton animation="wave" width='100%' height={50} />
          <Skeleton animation="wave" width='100%' height={50} />
        </Col>
      </Row>

      <div className="d-flex flex-wrap">
        <Skeleton className="me-3" animation="wave" width={100} height={50} />
        <Skeleton className="me-3" animation="wave" width={100} height={50} />
        <Skeleton className="me-3" animation="wave" width={100} height={50} />
      </div>

      <Divider className="mb-1" />

      <div className='d-flex justify-content-end'>
        <Skeleton animation="wave" width={150} height={50} />
      </div>

      <Skeleton variant="rectangular" animation="wave" width='100%' height={1100} />

      <div className='d-flex justify-content-end'>
        <Skeleton animation="wave" width={150} height={50} />
      </div>
    </Box>
  </>;
}

export default PeriodChurnReportSkeleton;
